// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/dragdata/style/index.less
// module id = 503
// module chunks = 0